export default __webpack_public_path__ + "static/media/app-bar-save.e8cff702.svg";